export type { EpochType } from "./EpochType.js";

import { equals } from "./equals.js";
import { from } from "./from.js";
import { toBigInt } from "./toBigInt.js";
import { toNumber } from "./toNumber.js";
import { toSlot } from "./toSlot.js";

export { from, toNumber, toBigInt, equals, toSlot };

export const Epoch = {
	from,
	toNumber,
	toBigInt,
	equals,
	toSlot,
};
